/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    array,
    arrayOf,
    number,
    object,
    func,
    shape,
    string,
    bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Modal from '@material-ui/core/Modal';
import Media from 'react-media';
import Dialog from '@material-ui/core/Dialog';
import IconClose from '@material-ui/icons/Close';
import AddonItemsContainer from './AddonItemsContainer/AddonItemsContainer';
import { addToCartDataType } from '../../common/types';

const styles = (theme) => ({
    modalContainer: {
        padding: '0',
        position: 'relative',
        backgroundColor: `${theme.palette.white} !important`,
        minHeight: '593px',
        borderRadius: 5,
        justifyContent: 'center',
        margin: '50px auto',
        flexDirection: 'row',
        maxWidth: 1180,
        '&:focus': {
            outline: 'none',
        },
    },
    modalContainerMobile: {
        padding: '0',
        position: 'relative',
        minHeight: '593px',
        borderRadius: 5,
        justifyContent: 'center',
        marginTop: 30,
        margin: '15px auto',
        flexDirection: 'row',
        maxWidth: 1180,
        '&:focus': {
            outline: 'none',
        },
    },
    icon: {
        color: theme.palette.colorIconHeader,
        marginRight: 10,
    },
    modalBackdropProps: {
        backgroundColor: theme.palette.bgPopup,
    },
    headerModal: {
        display: 'flex',
    },

    headerModalStickySpacer: {
        minHeight: 15,
    },
    productModal: {
        float: 'left',
        display: 'block',
        margin: '10px',
    },
    headingLine: {
        borderBottomWidth: `1px solid ${theme.palette.modalBorder}!important`,
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 10,
    },
    productHeading: {
        color: theme.palette.colorIconHeader,
        fontSize: '16px',
        lineHeight: '1.8em',
        fontWeight: '700',
        fontFamily: theme.typography.secondaryFontFamily,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    wineHeading: {
        color: theme.palette.colorIconHeader,
        fontSize: '16px',
        lineHeight: '1.8em',
        fontWeight: '700',
        fontFamily: theme.typography.secondaryFontFamily,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0px 0px 0px 220px',
    },
    productImage: {
        width: 'auto !important',
        height: '209px !important',
    },
    addedProductContainer: {
        border: `1px solid ${theme.palette.modalBorder}`,
        height: '430px',
        width: '330px',
        backgroundColor: theme.palette.modalBorder,
    },
    productDetails: {
        border: `2px solid ${theme.palette.modalBorder}`,
        height: '150px',
        width: '266px',
        margin: '5px',
        borderRadius: 5,
    },
    name: {
        flexDirection: 'colummn',
    },
    prices: {
        fontSize: '16px',
        fontWeight: '500',
        fontFamily: theme.typography.fontFamily,
        textAlign: 'Right',
        margin: '20px',
        color: theme.palette.colorIconHeader,
    },
    wineImage: {
        height: '50px',
        width: '50px',
    },
    subTotal: {
        height: '40px',
        width: '60px',
        border: `1px solid ${theme.palette.black}`,
        flexDirection: 'row',
    },
    addedProduct: {
        display: 'flex',
        flexDirection: 'row',
        height: '80px',
    },
    addedImage: {
        width: '109px',
        height: '115px',
        textAlign: 'left',
        margin: '10px',
    },
    titleModal: {
        flex: '2 0 auto',
        color: theme.palette.colorIconHeader,
        fontSize: '16px',
        lineHeight: '1.8em',
        fontWeight: '600',
        fontFamily: theme.typography.secondaryFontFamily,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0',
        padding: '0 10px',
    },
    addedProductName: {
        textAlign: 'right',
        fontSize: '18px',
        color: theme.palette.colorIconHeader,
        margin: '20px',
        fontWeight: '500',
        fontFamily: theme.typography.fontFamily,
    },
    options: {
        display: 'flex',
        flexDirection: 'row',
    },
    addedProductPrice: {
        textAlign: 'right',
        padding: '5px',
    },
    productLine: {
        border: `1px solid ${theme.palette.productLine}`,
        width: '300px',
        margin: '35px 0px 0px 12px',
    },
    shipping: {
        width: '153px',
        fontSize: '14px',
        color: theme.palette.colorIconHeader,
        fontFamily: theme.typography.fontFamily,
        margin: '14px',
    },
    wine: {
        padding: 10,
    },
    addonDialog: {
        padding: 0,
    },
    total: {
        fontSize: '14px',
        color: theme.palette.colorIconHeader,
        fontWeight: '400',
        fontFamily: theme.typography.fontFamily,
        margin: '18px 0px 0px 55px',
    },
    shippingContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    imageWine: {
        height: '200px',
        width: '200px',
        margin: '30px',
    },
    Line: {
        border: `1px solid ${theme.palette.productLine}`,
        maxWidth: 1155,
        margin: '0px 0px 0px 12px',
    },
    heading: {
        display: 'flex',
        flexDirection: 'row',
    },
    errorLoader: {
        textAlign: 'center',
        width: '100%',
        marginTop: 25,
        fontSize: '2em',
    },
    closeAction: {
        textDecoration: 'underline',
        fontSize: 18,
    },
});

class GraphqlModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAddons: [],
            counter: 0,
        };
    }

    render() {
        const { selectedAddons, counter } = this.state;
        const {
            classes,
            product,
            skuData,
            onCloseModal,
            product: {
                brandId,
                partNumber,
            },
            categoryId,
            subscription,
            subscriptionDetails,
            presentation_family,
            disableAddToCart,
            isAddToCartEnabled,
            categoryPath,
            categoryName,
            selectedSku,
            productSkus,
            deliveryData,
            updateWineStatus,
            handleMiniCartModalClick,
            mobileAgeVerificationOpen,
            handleMobileAgeVerification,
            addToCartData,
        } = this.props;
        return (

            <Media
                query="(max-width: 600px)"
            >
                {(matches) => (
                    matches ? (
                        <Dialog open fullScreen>
                            <div className={classes.modalContainerMobile}>
                                <div className={classes.mainContainer}>
                                    <AddonItemsContainer
                                        style={classes}
                                        product={product}
                                        selectedAddons={selectedAddons}
                                        counter={counter}
                                        skuData={skuData}
                                        onCloseModal={onCloseModal}
                                        brandId={brandId}
                                        partNumber={partNumber}
                                        categoryId={categoryId}
                                        subscription={subscription}
                                        subscriptionDetails={subscriptionDetails}
                                        presentation_family={presentation_family}
                                        disableAddToCart={disableAddToCart}
                                        isAddToCartEnabled={isAddToCartEnabled}
                                        categoryPath={categoryPath}
                                        categoryName={categoryName}
                                        selectedSku={selectedSku}
                                        productSkus={productSkus}
                                        updateWineStatus={updateWineStatus}
                                        deliveryData={deliveryData}
                                        handleMiniCartModalClick={handleMiniCartModalClick}
                                        mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                                        handleMobileAgeVerification={handleMobileAgeVerification}
                                        addToCartData={addToCartData}
                                        isMobile
                                    />
                                </div>
                            </div>
                        </Dialog>
                    ) : (
                        <Modal open BackdropProps={{ classes: { root: classes.modalBackdropProps } }}>
                            <div className={classes.modalContainer}>
                                <div className={classes.headerModal}>
                                    <h2 className={classes.titleModal}>Make it extra special</h2>
                                    {/* The close button */}
                                    <div
                                        className={classes.iconHeader}
                                        onClick={onCloseModal}
                                        onKeyDown={() => { }}
                                        role="button"
                                        tabIndex={-1}
                                    >
                                        <IconClose className={classes.icon} />
                                    </div>
                                </div>
                                <div className={classes.Line} />
                                <div className={classes.mainContainer}>

                                    <AddonItemsContainer
                                        style={classes}
                                        product={product}
                                        selectedAddons={selectedAddons}
                                        counter={counter}
                                        skuData={skuData}
                                        onCloseModal={onCloseModal}
                                        brandId={brandId}
                                        partNumber={partNumber}
                                        categoryId={categoryId}
                                        subscription={subscription}
                                        subscriptionDetails={subscriptionDetails}
                                        presentation_family={presentation_family}
                                        disableAddToCart={disableAddToCart}
                                        isAddToCartEnabled={isAddToCartEnabled}
                                        categoryPath={categoryPath}
                                        categoryName={categoryName}
                                        selectedSku={selectedSku}
                                        productSkus={productSkus}
                                        updateWineStatus={updateWineStatus}
                                        deliveryData={deliveryData}
                                        handleMiniCartModalClick={handleMiniCartModalClick}
                                    />
                                </div>
                            </div>
                        </Modal>
                    )
                )}
            </Media>

        );
    }
}
GraphqlModal.propTypes = {
    classes: object.isRequired,
    onCloseModal: func.isRequired,
    handleMiniCartModalClick: func.isRequired,
    updateWineStatus: func.isRequired,
    product: shape({
        id: string.isRequired,
        name: string.isRequired,
        brandId: string.isRequired,
        partNumber: string.isRequired,
    }).isRequired,
    skuData: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                }),
            ).isRequired,
        }),
    ).isRequired,
    deliveryData: shape({
        location_type_options: arrayOf(
            shape({
                name: string,
                value: string,
            }),
        ),
        show: bool,
        title: string,
        zip_code_title: string,
        location_type_title: string,
    }),
    categoryId: string.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    presentation_family: string.isRequired,
    disableAddToCart: bool,
    isAddToCartEnabled: bool,
    categoryPath: string.isRequired,
    categoryName: string.isRequired,
    selectedSku: shape({
        id: string.isRequired,
        minAge: string.isRequired,
    }).isRequired,
    productSkus: shape({
        minAge: string.isRequired,
    }).isRequired,
    mobileAgeVerificationOpen: bool,
    handleMobileAgeVerification: func,
    addToCartData: addToCartDataType,
};

GraphqlModal.defaultProps = {
    isAddToCartEnabled: true,
    subscriptionDetails: {},
    disableAddToCart: false,
    subscription: {},
    deliveryData: {},
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: () => { },
    addToCartData: {},
};
export default (withStyles(styles)(GraphqlModal));
